import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { rem } from "polished"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
// import Pagination from "../components/pagination"
import PostsHighlightsFullScreen from "../components/posts-highlights-fullscreen"
import PostCard from "../components/post-card"
import { ReactComponent as SvgBulb } from "../assets/images/icons/bulb.svg"

const Grid = styled.ul`
  ${({ theme }) => theme.grid.container()}
  ${({ theme }) => theme.grid.grid()}
  ${({ theme }) => theme.grid.gridGutterX()}
  ${({ theme }) => theme.grid.gridGutterY(30)}

  margin-top: ${rem(40)};
  margin-bottom: ${rem(40)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    margin-top: ${rem(20)};
    margin-bottom: ${rem(20)};
  }

  > li {
    ${({ theme }) => theme.grid.cell(4)}

    @media ${({ theme }) => theme.mq.xlargeDown} {
      ${({ theme }) => theme.grid.cell(6)}
    }

    @media ${({ theme }) => theme.mq.smallDown} {
      ${({ theme }) => theme.grid.cell(12)}
    }
  }
`

const HighlightsWrapper = styled.div`
  padding-bottom: ${rem(50)};
  background-color: ${({ theme }) => theme.colors.timberWolf};
`

const ArticlesPage = ({ data: { config, articles } }) => {
  const heroItemsMax = 100
  let heroItems = null
  let gridItems = null

  if (articles && articles.nodes.length >= heroItemsMax) {
    heroItems = articles.nodes.slice(0, heroItemsMax)
    gridItems = articles.nodes.slice(heroItemsMax)
  } else {
    heroItems = articles.nodes
  }

  return (
    <Layout>
      {heroItems && heroItems.length > 0 && (
        <HighlightsWrapper>
          <PostsHighlightsFullScreen
            data={heroItems}
            heading={config.pages.articles.title}
            headingLevel={1}
            icon={<SvgBulb />}
          />
        </HighlightsWrapper>
      )}

      {gridItems && gridItems.length > 0 && (
        <React.Fragment>
          <Grid>
            {gridItems.map((item, i) => (
              <li key={i}>
                <PostCard data={item} />
              </li>
            ))}
          </Grid>

          {/* <Pagination pageCount={4} onPageChange={() => null} /> */}
        </React.Fragment>
      )}
    </Layout>
  )
}

export default ArticlesPage

export const Head = ({ data: { config } }) => {
  return <Meta data={{ title: config.pages.articles.title }} />
}

export const pageQuery = graphql`
  query {
    config: configJson {
      pages {
        articles {
          title
        }
      }
    }

    articles: allArticlesJson(sort: { publish_at: DESC }) {
      nodes {
        ...ArticlesCardFragment
      }
    }
  }
`
